import { html, LitElement, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";

import { type Video } from "./bible-video-player-overlay";

import css from "./bible-video-feature.css?inline";

@customElement("bible-video-feature")
export class VideoFeatureElement extends LitElement {
  static styles = unsafeCSS(css);

  @property()
  description: string = null!;

  @property({ attribute: "image-url" })
  imageUrl: string = null!;

  @property()
  video: Video = null!;

  render() {
    return html`
      <div
        class="video"
        part="video"
        style=${styleMap({
          "--image-url": `url(${this.imageUrl})`,
        })}
      >
        <div class="video__content" part="video-content">
          <h2 part="video-content-title">${this.title}</h2>
          <p>${this.description}</p>
          <bible-video-play-button
            .video=${this.video}
          ></bible-video-play-button>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bible-video-feature": VideoFeatureElement;
  }
}
